import { render, staticRenderFns } from "./ContentArea.vue?vue&type=template&id=2922d5b0&scoped=true&"
import script from "./ContentArea.vue?vue&type=script&lang=js&"
export * from "./ContentArea.vue?vue&type=script&lang=js&"
import style0 from "./ContentArea.vue?vue&type=style&index=0&id=2922d5b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922d5b0",
  null
  
)

export default component.exports